<template>
  <div class="max-w-6xl mx-auto my-10">
    <h2 class="text-xl text-gray-700 py-4">Whatsapp API Approval</h2>
    <nav aria-label="Progress">
      <ol role="list" class="space-y-4 md:flex md:space-y-0 md:space-x-8">
        <li class="md:flex-1" v-for="(step, index) in steps" :key="index">
          <!-- Completed Step -->
          <a
            class="group pl-4 py-2 flex flex-col border-l-4  md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4"
            :class="{
              'border-indigo-600 hover:border-indigo-800':
                step.isCompleted || currentStep.step === step.step,
              'border-gray-200 hover:border-gray-300': !step.isCompleted
            }"
            @click="gotoStep(step)"
          >
            <span
              class="text-xs  font-semibold tracking-wide uppercase "
              :class="{
                'text-indigo-600 group-hover:text-indigo-800':
                  step.isCompleted || currentStep.step === step.step,
                'text-gray-500 group-hover:text-gray-700': !step.isCompleted
              }"
              >Step {{ index + 1 }}</span
            >
            <span class="text-sm font-medium">{{ step.stepName }}</span>
          </a>
        </li>
      </ol>
    </nav>
    <div class="my-4">
      <div
        class="bg-white rounded-md p-4"
        v-if="currentStep.step === 'facebook_business_manager'"
      >
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Facebook Business Manager ID
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                Don't know what is FB manager Id is?
                <a
                  href="https://en-gb.facebook.com/business/help/1181250022022158?id=180505742745347"
                  target="_blank"
                  class="text-blue-500"
                  >Click here </a
                >.
              </p>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <img class="rounded-md p-4" src="../../assets/fbm.png" />
              </div>
              <div class="sm:col-span-3">
                <div>
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Facebook Business manager Id
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input
                      v-model="form.facebookManagerId"
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      autofocus
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Facebook Page URL
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input
                      v-model="form.facebookPageUrl"
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  :disabled="
                    $v.form.facebookManagerId.$invalid ||
                      $v.form.facebookPageUrl.$invalid
                  "
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75"
                  @click="showNextStep()"
                >
                  Next
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-white rounded-md p-4"
        v-if="currentStep.step === 'phone_number'"
      >
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Phone Number
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                This is the number you want to set up as your official WhatsApp
                number.
              </p>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <div>
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Phone Number (with country code)
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm flex-col">
                    <input
                      v-model="form.apiPhoneNumber"
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      autofocus
                    />
                    <p class="mt-2 text-sm text-gray-500">
                      this number should not be connected to whatsapp business /
                      whatsapp personal account. If it is already connected
                      please delete the account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  :disabled="$v.form.apiPhoneNumber.$invalid"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75"
                  @click="showNextStep()"
                >
                  Next
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-white rounded-md p-4"
        v-if="currentStep.step === 'business_details'"
      >
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Business Details
              </h3>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <div>
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Business name
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm flex-col">
                    <input
                      autofocus
                      v-model="form.businessName"
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                    <p class="mt-2 text-sm text-gray-500">
                      This is the name you have registered in the Facebook
                      business manager
                    </p>
                  </div>
                </div>
                <div>
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Business Physical Address
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm flex-col">
                    <input
                      v-model="form.businessAddress"
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  :disabled="
                    $v.form.businessName.$invalid ||
                      $v.form.businessAddress.$invalid
                  "
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75"
                  @click="showNextStep()"
                >
                  Next
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-white rounded-md p-4"
        v-if="currentStep.step === 'contact_details'"
      >
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Contact details
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                If we need any detail from your side regarding the whatsapp
                application we will use this number to contact you.
              </p>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <div>
                  <label
                    for="username"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Your Whatsapp Phone Number (with country code)
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm flex-col">
                    <input
                      v-model="form.contactPhoneNumber"
                      autofocus
                      class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  :disabled="$v.form.$invalid"
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75"
                  @click="submit()"
                >
                  Submit
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-white rounded-md p-4"
        v-if="currentStep.step === 'processing_application'"
      >
        <div class="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-green-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 class="text-xl text-cool-gray-700 pl-4">
            Your application is submitted and its getting processed.
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndex } from "lodash-es";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      steps: [
        {
          stepName: "Facebook Business Manager Id",
          isCompleted: true,
          step: "facebook_business_manager"
        },
        { stepName: "Phone Number", isCompleted: false, step: "phone_number" },
        {
          stepName: "Business Details",
          isCompleted: false,
          step: "business_details"
        },
        {
          stepName: "Contact Details",
          isCompleted: false,
          step: "contact_details"
        },
        {
          stepName: "Processing Application",
          isCompleted: false,
          step: "processing_application"
        }
      ],
      currentStep: {},
      form: {
        facebookManagerId: "",
        facebookPageUrl: "",
        apiPhoneNumber: "",
        businessName: "",
        businessAddress: "",
        contactPhoneNumber: ""
      }
    };
  },
  validations: {
    form: {
      facebookManagerId: {
        required
      },
      facebookPageUrl: {
        required
      },
      apiPhoneNumber: {
        required
      },
      businessName: {
        required
      },
      businessAddress: {
        required
      },
      contactPhoneNumber: {
        required
      }
    }
  },
  created() {
    this.$store.dispatch("getWhatsappApiApplication").then(response => {
      if (
        response.application &&
        response.application.status === "processing"
      ) {
        for (const step of this.steps) {
          step.isCompleted = true;
        }
        this.currentStep = this.steps[this.steps.length - 1];
      } else {
        this.currentStep = this.steps[0];
      }
    });
  },
  methods: {
    showNextStep() {
      if (this.currentStep.step === "contact_details") {
        if (this.form.apiPhoneNumber === this.form.contactPhoneNumber) {
          alert("Contact phone number and API phone number should not be same");
          return;
        }
      }
      const currentStepIndex = findIndex(this.steps, {
        step: this.currentStep.step
      });

      this.currentStep.isCompleted = true;
      this.currentStep = this.steps[currentStepIndex + 1];
    },
    gotoStep(step) {
      if (step.isCompleted) {
        this.currentStep = step;
      }
    },
    submit() {
      const payload = {
        ...this.form,
        neededFeature: this.$route.query.feature
      };
      this.$store
        .dispatch("addWhatsappApiApplication", {
          requestParams: payload
        })
        .then(() => {
          this.showNextStep();
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
